<template>
  <base-dialog v-bind="$attrs" width="480px" @handleClose="handleClose"
               @handleConfirm="handleConfirm" :show-close="false">
    <template #title>{{$t('common.del') + $t('common.tips')}}</template>
    <div class="main-text">{{$t('common.delTips')}}</div>
    <template #confirm>{{$t('common.del')}}</template>
  </base-dialog>
</template>

<script>
export default {
  name: 'CorpusDeleteDialog',
  props: {
    deleteType: {
      type: String,
      default: ""
    }
  },
  methods: {
    handleClose() {
      this.$emit('handleClose');
    },
    handleConfirm() {
      this.$emit('handleConfirm');
    }

  }
}
</script>

<style lang="less" scoped>
/deep/.el-dialog__header {
  padding-bottom: 0px !important;
}
/deep/.el-dialog__body {
  margin: 40px 0 40px 0;
  padding: 0 20px;
  .main-text {
    word-break: break-word;
    font-size: 16px;
  }
}
/deep/.el-dialog__footer {
  padding-bottom: 30px;
  .confirm-btn {
    background-color: #ff6969;
    border-color: #ff6969;
    &:hover {
      background-color: lighten(#ff6969, 5%);
      border-color: lighten(#ff6969, 5%);
    }
    &:active {
      background-color: darken(#ff6969, 5%);
      border-color: darken(#ff6969, 5%);
    }
  }
}
</style>